import * as authenticationActions from '@lib/actions/AuthenticationAction';
import * as siteActions from '@lib/actions/SiteAction';
import { addTranslateToProps, ITranslationProps } from '@lib/i18n/translation';
import DashBoard from '@lib/pages/DashBoard';
import { ISite, IStoreSiteState } from '@lib/types/index';

import { connect, Dispatch } from 'react-redux';

export function mapStateToProps(state: any): IDashBoardProps {
  const siteState: IStoreSiteState = state.site;
  return addTranslateToProps({
    errorMessage: siteState.errorMessage,
    login: state.authentication.login,
    pendingOrder: siteState.pendingOrder,
    push: siteState.push,
    site: siteState.site,
    syncing: siteState.syncing,
    token: siteState.token,
  })
}

export function mapDispatchToProps(dispatch: Dispatch<any>) {
  return {
    onChangeOuput: (idDevice: string, id: number, value: number) => dispatch(siteActions.asyncOutputChangeStateAction(idDevice, id, value)),
    onEditInput: (no: number) => dispatch(siteActions.editInputNavigate(no)),
    onEditOutput: (no: number) => dispatch(siteActions.editOutputNavigate(no)),
    onEditTemperature: (no: number) => dispatch(siteActions.editTemperatureNavigate(no)),
    onEditThermostat: (no: number) => dispatch(siteActions.editThermostatNavigate(no)),
    onGoChangePassword: () => document.location.hash = 'changePassword',
    onGoHome: () => dispatch(authenticationActions.signOutAction()),
    onGoSiteList: () => document.location.hash = 'home',
    onPushClick: (subscribe: boolean, token: string) => subscribe ? dispatch(siteActions.asyncPushSubscribeAction(token)) : dispatch(siteActions.asyncPushUnsubscribeAction(token)),
    onSelect: (idDevice: string, name: string) => dispatch(siteActions.asyncSiteSelectAction(idDevice, name, false)),
    onSync: (idDevice: string) => dispatch(siteActions.asyncSyncSiteAction(idDevice)),
    onViewAlarmList: (idDevice: string) => dispatch(siteActions.asyncAlarmListAction(idDevice)),
    onViewLogEventList: (idDevice: string) => dispatch(siteActions.asyncLogEventsAction(idDevice)),
    onViewUserList: (idDevice: string) => dispatch(siteActions.asyncUserListAction(idDevice)),
    // onSync: (idDevice: string) => dispatch(siteActions.asyncUpdateSiteAction(idDevice)),
  }
}

interface IDashBoardProps extends ITranslationProps {
  errorMessage: string;
  login: string;
  push: boolean;
  site: ISite;
  syncing: boolean;
  pendingOrder: number;
  token: string;
}

interface IDashBoardDispatchProps {
  onChangeOuput(idDevice: string, id: number, value: number): void;
  onGoChangePassword(): void
  onEditInput(no: number): void;
  onEditOutput(no: number): void;
  onEditTemperature(no: number): void;
  onEditThermostat(no: number): void;
  onGoHome(): void;
  onGoSiteList(): void;
  onPushClick(subscribe: boolean, token: string): void;
  onSelect(mac: string, name: string): void;
  onSync(mac: string): void;
  onViewAlarmList(idDevice: string): void;
  onViewLogEventList(idDevice: string): void;
  onViewUserList(idDevice: string): void;
}

export type DashBoardProps = IDashBoardProps & IDashBoardDispatchProps;

export default connect<IDashBoardProps, IDashBoardDispatchProps, any>(mapStateToProps, mapDispatchToProps)(DashBoard);


// WEBPACK FOOTER //
// ./src/containers/DashBoard.tsx